/* eslint-disable react/void-dom-elements-no-children */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Parser } from 'html-to-react';
import draftToHtml from 'draftjs-to-html';
import ArrowIcon from '../Images/Icons/icon_arrow_down_black.svg';

class FAQComponent extends Component {
  constructor() {
    super();

    this.htmlToReactParser = new Parser();
  }

  render() {
    const {
      content,
      divider,
    } = this.props;

    this.state = {
      content,
    };

    const toggleQuestion = (index) => {
      const list = this.state.content.map((question, j) => {
        if (j === index) {
          if (question.showAnswer == null) {
            question.showAnswer = true;
          } else {
            question.showAnswer = !question.showAnswer;
          }
        }

        return question;
      });

      this.setState({ content: list });
    };

    return (
      <div>
        <ul className="main-text-content faq-wrapper">
          {this.state.content.map((question, index) => (
            <li key={question.header} className="question-container">
              <div
                className="question"
                onClick={() => toggleQuestion(index)}
              >
                <b>{question.header}</b>
                <img className={question.showAnswer ? 'flip' : ''} src={ArrowIcon} alt="arrow" />
              </div>

              {question.showAnswer && (
                <div className={`answer-${question.showAnswer ? 'show' : 'hide'}`}>
                  {this.htmlToReactParser.parse(draftToHtml(question.text))}
                </div>
              )}
            </li>
          ))}
        </ul>
        { divider &&
          <div>
            <hr className="divider" />
          </div>
        }
      </div>
    );
  }
}


export default FAQComponent;



// WEBPACK FOOTER //
// ./src/Components/FAQComponent.js